import noviceCert from "../../img/profile/certificates/novice.png";
import intermediateCert from "../../img/profile/certificates/intermediate.png";
import expertCert from "../../img/profile/certificates/expert.png";
import salesCert from "../../img/profile/certificates/sales-consultant.png";
import servicesCert from "../../img/profile/certificates/services-consultant.png";
import sparkCert from "../../img/profile/certificates/spark.png";
import adminCert from "../../img/profile/certificates/admin.png";
import aiSkillsCert from "../../img/profile/certificates/ai-skills.png";
import guestsCert from "../../img/profile/certificates/guests.png";
import capacityPlanningCert from "../../img/profile/certificates/capacity-planning.png";
import chatCert from "../../img/profile/certificates/chat.png";

import verifiedBadges from "../../img/profile/verified-badges-2x-min.png";

import addCircle from "../../img/svg/add-circle.svg";
import operator from "../../img/svg/operator.svg";
import speak from "../../img/svg/speak.svg";

export default function updateProfilePage() {
  // update title meta tag
  let pageTitle = document.querySelector("title");
  pageTitle.innerText = "Profile";

  let profileContent = document.querySelector("#skilljar-content");
  let profileHeader = document.querySelector(".sj-grey-bg-v2");
  let profileUpdateButton = document.querySelector(".sj-update-profile-v2");
  profileUpdateButton.querySelector("span").innerText = "Save changes and exit";

  $(document).ready(() => {
    // pull all profile page data
    let profileData = document.querySelectorAll(".row.show-for-small");
    let certificateData = [];

    // build tabs
    let tabRow = document.createElement("div");
    tabRow.classList.add("tab-row");

    // build tab content container
    let tabContainer = document.createElement("div");
    tabContainer.classList.add("tab-container");

    // populate profile data sections & find certificates
    profileData.forEach((section, i) => {
      // create tab for section
      let title = section.querySelector("h4 span").innerText;
      let titleClass = title.toLowerCase().replace(" ", "-");

      let tab = document.createElement("button");
      tab.classList.add("tab");
      tab.classList.add(`tab-${titleClass}`);
      i === profileData.length - 1 && tab.classList.add("active");
      tab.innerHTML = title;

      // tab handler logic
      tab.onclick = (e) => {
        let allTabs = document.querySelectorAll(".tab");
        allTabs.forEach((tab) => tab.classList.remove("active"));
        e.target.classList.add("active");

        let allTabContent = document.querySelectorAll(".tab-content");
        allTabContent.forEach((tabContent) =>
          tabContent.classList.remove("active"),
        );

        let newActiveTab = document.querySelector(`.tab-content-${titleClass}`);
        newActiveTab.classList.add("active");
      };

      tabRow.append(tab);

      // populate tab content
      let courses = section.querySelectorAll(".profile-course-info");

      let tabContent = document.createElement("div");
      tabContent.classList.add("tab-content");
      tabContent.classList.add(`tab-content-${titleClass}`);
      i === profileData.length - 1 && tabContent.classList.add("active");

      courses.forEach((course) => {
        let courseTitle = course
          .querySelector(".profile-course-info-title")
          .innerText.trim();

        let courseContainer = document.createElement("div");
        courseContainer.classList.add("course-info");
        courseContainer.classList.add("course-container");
        courseContainer.innerHTML = course.innerHTML;

        // update cloned registration checkboxes to click existing ones
        // this essentially "reattaches" the checkboxes to their event listeners
        let registrationCheckbox = course.querySelector(
          '.receive-notifications input[type="checkbox"]',
        );

        if (registrationCheckbox) {
          let clonedCheckbox = courseContainer.querySelector(
            '.receive-notifications input[type="checkbox"]',
          );
          clonedCheckbox.addEventListener("click", () =>
            registrationCheckbox.click(),
          );
        }

        // check if course is a completed certificate
        if (
          courseTitle.includes("Certificate Exam") ||
          courseTitle.includes("Qualification") ||
          courseTitle.includes("Certificate of Completion") ||
          courseTitle.includes("Knowledge Certification") ||
          courseTitle.includes("Knowledge Check")
        ) {
          courseContainer.classList.add("certificate-exam");

          let completedCourse = course.querySelector(
            ".sj-text-certificate-completed",
          );

          if (completedCourse && !completedCourse.innerText.includes("--")) {
            const certAnchor = course.querySelector(
              ".profile-course-info-details a.focus-link-v2",
            );

            const linkedInAnchor = course.querySelector(
              ".profile-course-info-details a.focus-link-v2 + br + div a",
            );

            let certData = {
              courseTitle: courseTitle,
              certLink: certAnchor ? certAnchor.href : null,
              linkedInLink: linkedInAnchor ? linkedInAnchor.href : null,
            };

            switch (courseTitle) {
              case "ClickUp Novice Certificate Exam":
                certData.certImage = noviceCert;
                break;
              case "Build Your First Workflow Certificate Exam":
                certData.certImage = intermediateCert;
                break;
              case "ClickUp Expert Certificate Exam":
                certData.certImage = expertCert;
                break;
              case "ClickUp Sales Qualification":
                certData.certImage = salesCert;
                break;
              case "ClickUp Service Delivery Qualification":
                certData.certImage = servicesCert;
                break;
              case "SPARK Certificate of Completion":
                certData.certImage = sparkCert;
                break;
              case "ClickUp Admin Certificate Exam":
                certData.certImage = adminCert;
                break;
              case "ClickUp AI: Knowledge Certification":
                certData.certImage = aiSkillsCert;
                break;
              case "ClickUp for Guests Certificate Exam":
                certData.certImage = guestsCert;
                break;
              case "Capacity Planning: Knowledge Certification":
                certData.certImage = capacityPlanningCert;
                break;
              case "ClickUp Chat: Knowledge Check":
                certData.certImage = chatCert;
                break;
              default:
                console.log("❌", courseTitle, "cert not found");
                break;
            }

            certificateData.push(certData);
          }
        }

        tabContent.append(courseContainer);
      });

      tabContainer.append(tabContent);
    });

    // inject certificate section
    if (certificateData.length > 0) {
      let certificatesSection = document.createElement("div");
      certificatesSection.classList.add("certificates-section");
      certificatesSection.innerHTML = `
                <h2>Certifications</h2>
            `;

      let certificatesContainer = document.createElement("div");
      certificatesContainer.classList.add("certificates-container");

      certificateData.forEach((certificate) => {
        let certBox = document.createElement("div");
        certBox.classList.add("certificate");

        if (certificate.certImage) {
        certBox.innerHTML = `
            <a href="${certificate.certLink}" class="certificate-pic" data-cert-title="${certificate.courseTitle}">
                <img src="${certificate.certImage}" class="novice certificate">
            </a>
            <a href="${certificate.linkedInLink}" class="add-to-linkedin">
                <img src="${addCircle}">
                <span>Add to your LinkedIn profile</span>
            </a>
        `;
        } else {
          certBox.innerHTML = `
              <a href="${certificate.certLink}" class="certificate-fallback" data-cert-title="${certificate.courseTitle}">
                  <div class="certificate-fallback-text">
                      <h3>Certificate of Completion</h3>
                      <p>${certificate.courseTitle}</p>
                  </div>
              </a>
              <a href="${certificate.linkedInLink}" class="add-to-linkedin">
                  <img src="${addCircle}">
                  <span>Add to your LinkedIn profile</span>
              </a>
          `;
        }

        certificatesContainer.append(certBox);
      });

      certificatesSection.append(certificatesContainer);
      profileHeader.after(certificatesSection);
    }

    profileHeader.after(tabContainer);
    profileHeader.after(profileUpdateButton);
    profileHeader.after(tabRow);
  });

  // inject "get verified" banner section
  let getVerifiedSection = document.createElement("div");
  getVerifiedSection.classList.add("get-verified-section");
  getVerifiedSection.innerHTML = `
        <div class="get-verified-container">
            <div class="get-verified-text">
                <h2>Get verified</h2>
                <p>
                    Become ClickUp Verified & get exclusive perks. Build your ClickUp expertise to earn custom badges, exclusive opportunities, and access to a community of ClickUp power users like you.
                </p>
                <a href="https://clickup.com/verified" class="get-verified-link">
                    Learn More
                </a>
            </div>
            <div class="get-verified-badges">
                <img src="${verifiedBadges}">
            </div>
        </div>
    `;

  profileContent.append(getVerifiedSection);

  // inject footer links section
  let footerLinksSection = document.createElement("div");
  footerLinksSection.classList.add("footer-links-section");

  let footerLinkData = [
    {
      icon: operator,
      title: "Help center",
      description: `Have a question about ClickUp University? <a>Contact us</a>`,
      url: "mailto:training@clickup.com",
    },
    {
      icon: speak,
      title: "Feedback",
      description: `Enjoying ClickUp University? We'd love to hear from you! <a>Take survey</a>`,
      url: "https://clickup.qualtrics.com/jfe/form/SV_5nH2ESKX1nIHEKG",
    },
  ];

  footerLinkData.forEach((link) => {
    let footerLink = document.createElement("a");
    footerLink.classList.add("footer-link");
    footerLink.href = link.url;
    footerLink.target = "_blank";
    footerLink.innerHTML = `
            <div class="footer-link-icon">
                <img src="${link.icon}" />
            </div>
            <div class="footer-link-text">
                <div class="footer-link-title">
                    ${link.title}
                </div>
                <div class="footer-link-description">
                    ${link.description}
                </div>
            </div>
        `;

    footerLinksSection.append(footerLink);
  });

  profileContent.append(footerLinksSection);
}
